import { Button } from 'primereact/button'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 1rem;
    flex-wrap: wrap;
`

export const ImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 5px;
    margin-bottom: 10px;
    gap: 5px;
`

export const SelectableImage = styled.img<{ isSelected: boolean }>`
    width: 100px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;

    border: 3px solid transparent;
    ${(props) =>
        props.isSelected &&
        `
        border-color: #ba9d31; 
    `}
`

export const RemoveButton = styled(Button)`
    width: 100px;
    height: 20px;
    color: #cc3333;
    background-color: #fff;
    border-color: #cc3333;
    border-radius: 6px;
    font-size: 14px;

    &:hover {
        color: #fff;
        background-color: #cc3333;
        border-color: #fff;
    }
`
